import { createGlobalStyle } from 'styled-components';

/**
 * Override design-system font to use Next.js localFont CSS variable.
 * This ensures buttons, selects, inputs, and other form elements properly
 * inherit the Figtree font loaded via Next.js localFont.
 *
 * The CSS variable --font-figtree is set by Next.js localFont in the root layout.
 */
export const FontOverride = createGlobalStyle`
	body,
	select,
	button,
	input,
	textarea {
		font-family: var(--font-figtree, 'Figtree'), 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !important;
	}
`;
